<template>
  <div class="content">
      <!-- 头部导航栏   -->
        <van-nav-bar  left-arrow fixed :placeholder="true" @click-left="onClickLeft" safe-area-inset-top v-if="navBar">
            <template #right>
                    <!-- 分享图标 -->
                    <!-- <van-image
                     width="18"
                     height="18"
                    :src="require('@/assets/images/btn_share.png')"
                    @click="showShare = true"
                     /> -->
            </template>
        </van-nav-bar>
            <!-- 新闻标题 -->
                <div v-if="show">
                    <div class="newsTitle">
                    <h1>{{title?title:''}}</h1>
                    <div class="info">
                            <div class="leftText van-ellipsis"><span>{{subtitle?subtitle:''}}</span></div> 
                            <div class="rightText"><span>{{newTime | formatDate_}}</span></div>

                    </div>
            </div>
            <div v-if="!content"></div>
            <div class="contentTxt" v-if="content" v-html="content"></div>
                </div>
                <div v-if="!show">
                    <van-empty
                       class="custom-image"
                       :image="require('@/assets/images/pic_no information@2x.png')"
                       description="暂无数据!"
                     />
                </div>
 <!-- 新闻底部 -->
      <div class="newsBtm">
           <div class="statementBox">
                <div class="statement">
                    <div class="flex"><van-icon name="bulb-o" /> <h5>免责声明</h5></div>
                    <p>
                        数据来源于网络，本平台尊重提倡保护知识产权，本文所引述机构或个人的观点、言论、数据及其他信息仅作参考和资讯传播之目的，不代表本平台赞同其观点或证实其描述。如对该系统链接服务存在异议，或发现违法及不良信息，请致电4001-886-722我们将及时处理。
                    </p>
                </div>
           </div>
          <img src="@/assets/images/pic_news_bottom@2x.png" alt="">
      </div>
  </div>
</template>

<script>
import * as api from "@/utils/api";
import {getNewsListContent} from'@/utils/api'
export default {
        data() {
            return {
                // 新闻数据
                newList:{},
                // 数据内容
                content:'',
                // 新闻标题
                title:'',
                // 时间
                newTime:'',
                // 副标题
                subtitle:'',
                // 分享面板的隐藏与显示
                showShare:false,
                options: [
                    { name: '微信', icon: 'wechat' },
                    { name: '微博', icon: 'weibo' },
                    { name: 'QQ', icon: 'qq' },
                    { name: '复制链接', icon: 'link' },
                    ],
                show:true,
                navBar:true,
            }
        },
        methods:{
            onClickLeft(){
                this.$router.push({
                    name:this.$route.query.path
                })
            }
        },
    async  created(){
            const id = this.$route.query.id
            this.navBar = this.$route.query.path =='news' || this.$route.query.path =='new'?true:false

            try{
                let res = await getNewsListContent(id)
                this.newList = res
                this.content = this.newList.content
                this.title = this.newList.title
                this.newTime = this.newList.created
                this.subtitle = this.newList.type
            }catch{
                    this.show = false
            }
        }
}
</script>

<style lang="scss">
.custom-image{
    height: 400px;
    width: 100%;
}
.content{
    overflow: hidden;
}
.van-hairline--bottom:after{
    border-bottom:none
}
.van-nav-bar__content{
        height: 90px;
        background-color: rgba(255, 255, 255,0.1);
         .van-nav-bar__left{
             .van-icon{
                 font-size: 40px;
                 color: #2a2a2a;
             }
         }
}
.newsTitle{
    // position: fixed;
    // top: 90px;
    // left: 0;
    // right: 0;
    // z-index: 666;
    // border-bottom: 1px solid transparent;
    width: 100%;
    padding: 0 24px 0 20px;
    h1{
        width: 100%;
        padding-right: 20px;
        font-size: 44px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 600;
        color: #1A1A1A;
        line-height: 58px;
        letter-spacing:2px;
        text-align: center;
    }
    .info{
        display: flex;
        margin-top: 20px;
        margin-bottom: 40px;
        width: 100%;
        span{
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 56px;
        }
        .leftText{
            width: 60%;
            margin-left: 10px;
            span{
                font-size: 24px;
            }
            
        }
        .rightText{
            width: 42%;
            text-align: right;
            span{
                font-size: 22px;
            }
        }
    }
}
.newsBtm{
    // position: fixed;
    // bottom: 0;
    // left: 0;
    width: 100%;
    img{
        width: 100%;
        height: 600px;
    }
    .statementBox{
        padding:  26px;
        .statement{
            width: 100%;
            height: 340px;
            border: 1px solid #cca756;
            border-radius: 12px;
            padding: 30px 26px 0px;
            font-size: 28px;
            color: #cca756;
            h5{
                margin-left: 10px;
            }
            p{
                line-height: 40px;
                margin-top: 6px;
            }
        }
    }
}
.van-popup{
    height: 280px;
    .van-share-sheet__header{
        padding: 16px 85px 12px;
        .van-share-sheet__title{
            font-size: 34px;
        }
    }
    .van-share-sheet__option {
         width: 200px;
         padding: 6px 0 4px 10px;
    }
    .van-share-sheet__cancel{
        font-size: 30px;
        line-height: 70px;
        margin-top: 14px;
    }
}
.contentTxt{
    width: 100%;
    height: 100%;
    padding: 0 26px;
    font-size: 28px;
    overflow: hidden;
    z-index: -1;
    p{
        overflow: hidden;
    }
}
.van-icon{
    font-size: 38px;
}
</style>